import * as React from "react";
import { connect } from "react-redux";
import { StoreState } from "../../reducers/root-reducer";
import { WithStyles, Theme, createStyles, withStyles } from "@material-ui/core";
import { translate, InjectedTranslateProps } from "react-i18next";
import IconButton from "@material-ui/core/IconButton";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import { ConnectedMobileMenu } from "./mobile-menu";
import { Dispatch } from 'redux';
import { openAddPaymentDialog } from '../../actions/store/app-actions';

export interface PaymentItemsProps {}

type Props = PaymentItemsProps &
	ReturnType<typeof mapStateToProps> &
	ReturnType<typeof mapDispatchToProps> &
	WithStyles<typeof styles> &
	InjectedTranslateProps;

export class PaymentItems extends React.Component<Props, {}> {
	public render() {
		const { classes, layout, openAddPaymentDialog } = this.props;

		return (
			<React.Fragment>
				<div className={classes.flexExpand} />
				<IconButton
					color="inherit"
					className="add-payment-button"
					onClick={openAddPaymentDialog}
				>
					<AddCircleOutlineIcon />
				</IconButton>
				{layout === "phone" && (
					<ConnectedMobileMenu />
				)}
			</React.Fragment>
		);
	}
}

const mapStateToProps = (state: StoreState) => ({
	layout: state.layout
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	openAddPaymentDialog: () => dispatch(openAddPaymentDialog())
});

const styles = (theme: Theme) =>
	createStyles({
		flexExpand: {
			flexGrow: 1
		}
	});

export const ConnectedPaymentItems = translate("translations")(
	withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(PaymentItems))
);
